export enum FinalCostsState {
  NotCompleted,
  Ready,
  ReadyRange,
  ReadyProForma,
  Calculating,
}
